import https from 'hub-http/clients/apiClient';
import getFromEarlyRequest from 'forms-utils-lib/earlyRequest/getFromEarlyRequest';
// @ts-expect-error untyped dependency
import { getDefaultUserPreferencesKey } from 'FormsUI/earlyRequest/earlyRequestsShared';
const BASE_URL = 'userpreferences/v1';
const _getDefaultUserPreferences = () => https.get(`${BASE_URL}/attributes`);
const getDefaultUserPreferences = () => getFromEarlyRequest(getDefaultUserPreferencesKey(), () => _getDefaultUserPreferences());
export default getDefaultUserPreferences;